/* eslint-disable */
// @ts-nocheck

/* eslint-enable prettier/prettier */
/* eslint-enable @typescript-eslint/no-unused-vars */
/* eslint-enable import/no-unresolved */

import React from "react";

import { Field } from "formik";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(() => ({
  wrapper: {
    display: "inline-block",
    maxWidth: "100%",
    marginBottom: "5px",
  },
  radio: {
    margin: "4px 0 0",
  },
  optionLabel: {
    marginLeft: "10px",
    fontWeight: "normal",
  },
  fieldset: {
    position: "relative",
  },
  legend: {
    position: "absolute",
    width: "1px",
    height: "1px",
    padding: 0,
    margin: "-1px",
    clip: "rect(0 0 0 0)",
    overflow: "hidden",
    whiteSpace: "nowrap",
    border: "0",
  },
}));

type TProps = {
  question: {
    options: {
      id: number;
      text: string;
      type: string;
    }[];
    id: number;
    text: string;
    mandatory: boolean;
  };
  errorMsg: string | null;
  submitCount: number;
};

function SurveySelectInput({ question, errorMsg, submitCount }: TProps) {
  const classes = useStyles();

  return (
    <fieldset
      aria-describedby={errorMsg ? `error-${question.id}` : undefined}
      aria-invalid={!!errorMsg}
      aria-required={question.mandatory}
      className={classes.fieldset}
      role="radiogroup"
    >
      <legend
        className={classes.legend}
      >{`${question.text} ${question.mandatory ? "*" : ""}`}</legend>
      {question.options.map((option) => {
        return (
          <div className="block" key={option.id}>
            <label className={classes.wrapper}>
              <Field
                type="radio"
                name={question.id}
                value={option.id.toString()}
                className={classes.radio}
              />
              <span className={classes.optionLabel}>{option.text}</span>
            </label>
          </div>
        );
      })}
      {errorMsg && (
        <span
          id={`error-${question.id}`}
          key={`error-${question.id}-${submitCount}`}
          className="sr-only"
          role="alert"
        >
          {I18n.t("surveys.error", { question: question.text })}
        </span>
      )}
    </fieldset>
  );
}

export default SurveySelectInput;
